/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Selected/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2FilterIcon from 'DesignSystem/Svgs/Tysiav2FilterIcon/index'



/** @type {import('Simple/types.js').View} */
export default function Selected({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Topbar/Content/FilterAction/Action/Selected"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let actionIsFullWidthValueData = fromData.useDataValue({ viewPath,
context: 'action',
path: 'is_full_width',
})
let actionIsFullWidthValueData1 = fromData.useDataValue({ viewPath,
context: 'action',
path: 'is_full_width',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let actionIsFullWidthValueData2 = fromData.useDataFormat({ viewPath,
context: 'action',
path: 'is_full_width',
format: fromFormat.not,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let tabSelectedTopbarAppointmentTypesValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.topbar_appointment_types',
format: fromFormat.listLength,
})
let actionIsFullWidthValueData3 = fromData.useDataValue({ viewPath,
context: 'action',
path: 'is_full_width',
})
let actionIsFullWidthValueData4 = fromData.useDataValue({ viewPath,
context: 'action',
path: 'is_full_width',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 height={dtSpaceM}
 paddingLeft={dtSpaceLs}
 paddingRight={dtSpaceLs}
>
{childProps => (
<React.Fragment>
<fromFlow.When is={actionIsFullWidthValueData}>
<Tysiav2FilterIcon
{...childProps}
  viewPath={`${viewPath}/Tysiav2FilterIcon`}
 data="action.is_full_width"
/>
</fromFlow.When>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 color={actionIsFullWidthValueData1 ? dtColorsNeutral400 : dtColorsNeutral900}
 marginLeft={actionIsFullWidthValueData1 ? dtSpaceXs : "0px"}
 text={actionIsFullWidthValueData1 ? "Showing slots for" : "Filter"}
 data="action.is_full_width"
/>
<fromFlow.When is={actionIsFullWidthValueData2}>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 text="("
 marginLeft={dtSpaceXxs}
 color={dtColorsNeutral400}
 data="action.is_full_width"
 format="/Data/format.js not"
/>
</fromFlow.When>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 data="tab.selected.topbar_appointment_types"
 format="/Data/format.js listLength"
 text={tabSelectedTopbarAppointmentTypesValueData}
 marginLeft={actionIsFullWidthValueData3 ? dtSpaceXxs : "0px"}
 color={actionIsFullWidthValueData3 ? dtColorsNeutral900 : dtColorsNeutral400}
 data="action.is_full_width"
/>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={actionIsFullWidthValueData4 ? dtSpaceXxs : "0px"}
 color={actionIsFullWidthValueData4 ? dtColorsNeutral900 : dtColorsNeutral400}
 text={actionIsFullWidthValueData4 ? "appointment types" : ")"}
 data="action.is_full_width"
/>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}